import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import main from '@/views/main'
import order from '@/views/order'
import order_detail from '@/views/order_detail'
import collect from '@/views/collect'
import view from '@/views/view'
Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', redirect: '/user' },
    {path: '/user',name: 'user',component: main, meta: {
      keepAlive: true
    }},
    {path: '/order',name: 'order',component: order ,meta: {
      keepAlive: false
    }},
    {path: '/order_detail',name: 'order_detail',component: order_detail ,meta: {
      
    }},
    {path: '/collect',name: 'collect',component: collect ,meta: {
      keepAlive: true
    }},
    {path: '/view',name: 'view',component: view ,meta: {
      keepAlive: true
    }},
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js